import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IDistributorImpact, IHeaderDistributorDetail } from '../../../interfaces/detail-header.interface';
import { EnumCardVerificationSection } from '../detail-registration/distributor-data/distributor-data.data';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DistributorService } from '../../../distributor.service';
import { IResponseNonActiveCustomer, ModalConfig } from '@shared/components/modal/modal.interface';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';
import { ModalFormComponent } from '@shared/components/modal/modal-form/modal-form.component';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { RolePrivilegeService } from '@services/role-privilege.service';

@Component({
  selector: 'app-detail-non-active',
  templateUrl: './detail-non-active.component.html',
  styleUrls: ['./detail-non-active.component.scss'],
})
export class DetailNonActiveComponent implements OnInit {
  @Input() detailHeaderSubject!: BehaviorSubject<IHeaderDistributorDetail>;

  snapshotParams!: Params;
  isLoading = new BehaviorSubject(false);
  impactedDistributor: IDistributorImpact | null = null;
  messageResponse: IResponseNonActiveCustomer;
  ctaApprovalPending: boolean;

  @ViewChild('modalConfirmVerification') modalConfirmVerification: ModalComponent;
  modalConfigConfirm: ModalConfig = {
    modalTitle: 'VERIFIKASI PENONAKTIFAN DISTRIBUTOR',
    showFooter: true,
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Lanjutkan',
    onDismiss: () => this.onSubmitConfirmation(),
  };

  @ViewChild('modalRequest') modalRequest: ModalFormComponent;
  modalConfigRequest: ModalConfig = {
    modalTitle: 'VERIFIKASI PENONAKTIFAN DISTRIBUTOR',
    showFooter: true,
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Lanjutkan',
    disableDismissButton: () => !this.RejectReasonForm.value,
    onDismiss: () => this.onSubmitConfirmation(),
  };

  @ViewChild('modalResponse') modalResponse: ModalComponent;
  modalResponseConfig: ModalConfig = {
    closeButtonLabel: 'Oke',
    dismissButtonLabel: 'Oke',
    hideCloseButton: () => true,
    onDismiss: () => this.goToDetail(),
  };

  form = this.fb.group({
    reject_reason: new FormControl('', [Validators.required]), // Array
  });

  get RejectReasonForm() {
    return this.form.get('reject_reason') as FormControl;
  }

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private distributorService: DistributorService,
    public utils: UtilitiesService,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private rolePrivilegeService: RolePrivilegeService
  ) {}

  ngOnInit() {
    this.snapshotParams = this.activeRoute.snapshot.params;
    this.getImpactedDistributor();
    this.handlePrivilege();
  }

  getImpactedDistributor() {
    this.distributorService.distributorImpactSubject.subscribe((value) => {
      if (Object.keys(value).length <= 0) return;
      this.impactedDistributor = value;
      this.ref.detectChanges();
    });
  }

  handlePrivilege() {
    this.ctaApprovalPending = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'DETAIL_DISTRIBUTOR', 'CTA_APPROVAL_PENDING_NONACTIVATED');
  }

  onVerification() {
    this.RejectReasonForm.setValue(null);
    this.modalConfirmVerification.open();
  }

  onRequest() {
    this.modalRequest.open();
  }

  onSubmitConfirmation() {
    const approval_enum = !this.RejectReasonForm.value ? 'APPROVED' : 'REJECTED';
    const payload = {
      approval_enum,
      reject_reason: this.RejectReasonForm.value,
    };
    this.distributorService.verificationNonActive(payload).subscribe((resp) => {
      if (resp && resp.success) {
        this.messageResponse = resp.data;
        this.modalResponse.open().then();
        this.ref.detectChanges();
      }
    });
    return true;
  }

  reloadPage() {
    return window.location.reload();
  }

  goToDetail() {
    const id = this.messageResponse.distributor_id;
    if (!this.RejectReasonForm.value) {
      // APPROVED
      this.router.navigate(['/distributor/detail/teregistrasi/non-active/' + id]).then(() => this.reloadPage());
    } else {
      // REJECTED
      this.router.navigate(['/distributor/detail/teregistrasi/active/' + id]).then(() => this.reloadPage());
    }
    return true;
  }

  protected readonly EnumCardVerificationSection = EnumCardVerificationSection;
  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
